import React, { useCallback } from 'react';
import { Button } from '@mui/material';
import { trackEvent } from '@surfline/web-common';
import { CLICKED_SUBSCRIBE_CTA } from '../../common/constants';

import styles from './PremiumWindStationCTA.module.scss';

interface Props {
  segmentProperties: {
    pageName: string;
  };
}

const MobilePremiumWindStationCTA: React.FC<Props> = ({ segmentProperties }) => {
  const handleClick = useCallback(
    () =>
      trackEvent(CLICKED_SUBSCRIBE_CTA, {
        ...segmentProperties,
        location: 'wind-station-map',
      }),
    [],
  );
  return (
    <div className={styles.mobileCta} data-testid="wind-stations-paywall-container">
      <div className={styles.buttonWrapper}>
        <Button
          variant="primary"
          className={styles.ctaButton}
          href="/upgrade"
          onClick={handleClick}
          aria-label="premium upgrade link"
          disableFocusRipple
          disableRipple
          disableTouchRipple
          data-testid="ctaButton"
        >
          Unlock with Premium
        </Button>
      </div>
    </div>
  );
};

export default MobilePremiumWindStationCTA;
